export default __webpack_public_path__ + "static/media/rival_coin.c4c5d1d9.svg";